import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-main',
  templateUrl: './spinner-main.component.html',
  styleUrls: ['./spinner-main.component.scss']
})
export class SpinnerMainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
